import React from 'react';
import { Image } from 'react-bootstrap';
import Button from './Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/POPIDisclaimerModal.css';
import cross from '../../Assets/ContainerStatus/Assets_Desktop/close-icon.svg';
import RespModal from './RespModal';

function POPIDisclaimerModal(props) {
    return (
        <RespModal hasOpen={props.hasOpen}>
            <div className="modalsizePOPIDisclaimerModal" id={!props.showButton && "modalsizeIdPOPIDisclaimerModal"}>
                {/* {props.showImage &&
                    <>
                        <Image src={props.showImagesrc} /><br /><br />
                    </>
                } */}
                {!props.showButton &&
                    <div className='POPIDisclaimermodalcross'>
                        <img src={cross} onClick={props.onCrossModal} width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy" />
                    </div>
                }
                <div class="POPIDisclaimerModalHeading">
                    {/* {props.modalHeading} */}
                    POPI Disclaimer
                    </div>
                <div id="modalcontainsuccessPOPIDisclaimerModal">
                    {/* {props.children} */}
                    <div class="POPIDisclaimerModalDiscripCss">
                        ‘The User acknowledges that this application contains their
                        personal information and hereby explicitly and unambiguously
                        consents to the collection, use, processing and transfer, in
                        electronic form, of their Personal Information by Transnet, and its
                        mandated officials for the purposes of providing the user access to
                        the Cargo Connect Platform. The User confirms that the Personal
                        Information provided is accurate and has been directly provided by
                        the User or a duly appointed Agent and the User indemnifies
                        Transnet for any loss or damage in the event the Personal
                        Information processed for the identified purpose is not accurate.’
                    </div>
                </div>
                {props.showButton &&
                    <div class="POPIDisclaimerModalbuttonouter">
                        <Button
                            id="cancelresploginbuttoPOPIDisclaimerModal"
                            type="button"
                            class="btn btn-dark"
                            onClick={props.onCloseModal}
                        >{props.buttonLabel}
                        </Button>
                    </div>
                }
            </div>
        </RespModal>
    );
}
export default POPIDisclaimerModal;
